import React from 'react';
import { urlFor } from '../sanityClient';

export default function TribuneItem({ heading, body, image, linkUrl, linkLabel }) {
  const lang = localStorage.getItem('language') || 'arm';
  const headingStr   = heading   ? (heading[lang]   || heading.en   || '') : '';
  const bodyStr      = body      ? (body[lang]      || body.en      || '') : '';
  const linkLabelStr = linkLabel ? (linkLabel[lang] || linkLabel.en || '') : '';
  const imgSrc       = image ? urlFor(image).width(600).url() : '';

  return (
    <section className='tribune-item-section main-container'>
      <div className='container-fluid'>
        <div className='row align-items-center'>
          {imgSrc && (
            <div className='col-lg-6 col-md-12 mb-4'>
              <img src={imgSrc} alt={headingStr} className='img-fluid' />
            </div>
          )}
          <div className={`col-lg-${imgSrc ? 6 : 12} col-md-12`}>
            {headingStr && <h2>{headingStr}</h2>}
            {bodyStr && <div dangerouslySetInnerHTML={{ __html: bodyStr }} />}
            {linkUrl && (
              <a href={linkUrl} className='btn btn-outline-dark mt-3'>
                {linkLabelStr || linkUrl}
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
